import logger from '3-foundation/Logging/logger';
import { queryCDA } from '3-foundation/CDA/queryCDA';
interface CDADictionaryItem {
	properties: {
		groupKeyReference: {
			properties: {
				groupKey: string;
			};
		}[];
		itemKey: string;
		value: string;
	};
}

interface CDADictionary {
	total: number;
	items: CDADictionaryItem[];
}

export const getDictionaryFromCDA = async ({ locale, preview }): Promise<Dictionary.Items> => {
	const profiler = logger.startTimer();
	const loggingName = 'getDictionary';
	try {
		const dictionary: CDADictionary = await queryCDA({
			url: 'umbraco/delivery/api/v2/content',
			urlParams: {
				filter: 'contentType:dictionaryItem',
				fields: 'properties[groupKeyReference,itemKey,value]',
				expand: 'properties[groupKeyReference]',
				take: '200', // TODO: Add warning if items are getting close to 200
			},
			locale,
			siteId: null,
			preview,
			logging: loggingName,
		});
		return {
			items: dictionary?.items.map((item) => {
				const { groupKeyReference, itemKey, value } = item?.properties ?? {};
				return {
					key: `${groupKeyReference?.[0]?.properties?.groupKey}.${itemKey}`,
					value,
				};
			}),
		};
	} finally {
		profiler.done({ message: loggingName, level: 'debug' });
	}
};
